require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-501-introduction-to-data-analysis-and-visualization-with-python.json") })
        }
      }, "path---courses-code-501-introduction-to-data-analysis-and-visualization-with-python");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-501-introduction-to-data-analysis-and-visualization-with-python!./.cache/json/courses-code-501-introduction-to-data-analysis-and-visualization-with-python.json
// module id = 1183
// module chunks = 231608221292675